import axios from "axios";
import { DataGrid, Template } from "devextreme-react";
import {
  ColumnChooser,
  ColumnFixing,
  Editing,
  Export,
  FilterRow,
  Grouping,
  HeaderFilter,
  Paging,
  Position,
  Scrolling,
  SearchPanel,
  Selection,
  Sorting,
  StateStoring,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import { useEffect, useMemo, useRef, useState } from "react";
import { getYearMonth } from "../../../common/date";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
// import columns from "./Columns";
import { saveAs } from "file-saver-es";
import Comment from "./Comment";
import { observerInstance } from "../../../common/ResizeObserver";
import { isQuotationRoot } from "../../../../utils/quotationHierarchy";

export default function SalesGrid(props) {
  const { sales, quot } = props;

  const salesGridRef = useRef(null);

  const [commentPopupVisible, setCommentPopupVisible] = useState(false);
  const [cTaskCategory, setCTaskCategory] = useState(null);

  const [dataSource, setDataSource] = useState(null);
  useEffect(() => {
    setDataSource(
      new CustomStore({
        key: ["quotNo", "codeNo"],
        load: async () => {
          const result = await axios.get(
            `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/sales/${quot.quotNo}`
          );

          return result.data;
        },
        update: async (key, values) => {
          await axios.put(
            `${process.env.REACT_APP_BECCO_API_URL}/api/salesMgmt/sales/sales/${key.quotNo}/${key.codeNo}`,
            values
          );
        },
      })
    );
  }, [sales.contrNo, quot.quotNo]);

  const groupCellRender = (options) => {
    const rows = options.data.items || options.data.collapsedItems || [];
    const root = rows.find((row) => row.isRoot) || rows[0];
    return `${root?.no || options.value}. ${root?.taskCat || ""} `;
  };

  const calculateSponsorDisplayValue = (data) => {
    return `${data.resp == 1 ? `V` : ``}`;
  };

  const calculateBeccoDisplayValue = (data) => {
    return `${data.resp == 2 ? `V` : ``}`;
  };

  const calculateNADisplayValue = (data) => {
    return `${data.resp == 3 ? `V` : ``}`;
  };

  const onCommentIconClick = (e) => {
    setCommentPopupVisible(true);
    setCTaskCategory(e.row.key);
  };

  const calculateDisplayValue = (data) => {
    if (data.no.indexOf(".") != -1) {
      switch (data.cost) {
        case "TBD":
        case "-":
          return data.cost;
        default:
          return Number(data.cost).toLocaleString();
      }
    } else {
      return "";
    }
  };
  const columns = (config) => {
    return [
      {
        dataField: "quotNo",
        caption: "Quotation No.",
        visible: false,
        width: 100,
        fixed: true,
      },
      {
        dataField: "codeNo",
        caption: "Code No.",
        visible: false,
        width: 100,
        fixed: true,
      },

      {
        dataField: "listNo",
        // groupIndex: 1,
        // caption: "List No",////
        dataType: "number",
        //groupCellRender: config.groupCellRender,
        groupCellTemplate: "listNo",
        visible: false,
        fixed: true,
      },
      {
        dataField: "no",
        caption: "No",
        dataType: "string",
        width: 60,
        allowEditing: false,
        fixed: true,
      },
      {
        dataField: "taskCat",
        caption: "Task Category",
        dataType: "string",
        width: 500,
        allowEditing: false,
        fixed: true,
      },
      {
        caption: "Responsibility",
        fixed: true,
        columns: [
          {
            caption: "Sponsor",
            width: 75,
            fixed: true,
            calculateDisplayValue: config.calculateSponsorDisplayValue,
          },
          {
            caption: "BECCO",
            fixed: true,
            calculateDisplayValue: config.calculateBeccoDisplayValue,
            width: 75,
          },
          {
            caption: "N/A",
            fixed: true,
            calculateDisplayValue: config.calculateNADisplayValue,
            width: 75,
          },
        ],
      },
      {
        dataField: "unit",
        caption: "Unit",
        dataType: "string",
        width: 110,
        allowEditing: false,
        fixed: true,
      },
      {
        dataField: "noOfUnit",
        caption: "No. of Unit",
        dataType: "string",
        width: 80,
        allowEditing: false,
        fixed: true,
      },
      {
        dataField: "unitCost",
        caption: "Unit Cost",
        dataType: "number",
        format: "#,##0",
        allowEditing: false,
        fixed: true,
      },
      {
        dataField: "cost",
        caption: "Cost",
        dataType: "number",
        format: "#,##0",
        allowEditing: false,
        fixed: true,
        calculateDisplayValue: calculateDisplayValue,
      },
      // {
      //   caption: "Comment",
      //   cellTemplate: "comment",
      // },
      {
        type: "buttons",
        allowHiding: false,
        fixed: true,
        fixedPosition: "left",
        buttons: [
          {
            hint: "Comments",
            icon: "fa-solid fa-comment",
            onClick: onCommentIconClick,
          },
        ],
      },
      {
        width: 50,
        fixed: true,
      },
      {
        dataField: "progRate",
        caption: "Progress Rate",
        dataType: "number",
        allowEditing: false,
        format: "0.00",
        fixed: true,
      },
    ];
  };

  // const calculateDisplayValue = (rowData, countDataField) => {
  //   console.debug("[calculateDisplayValue]");
  //   console.debug("rowData", rowData);
  //   console.debug("countDataField", countDataField);

  //   if (
  //     !rowData.noOfUnit ||
  //     rowData.noOfUnit == "" ||
  //     rowData.noOfUnit == "NA"
  //   ) {
  //     return 0;
  //   }

  //   return (rowData.cost * rowData[countDataField]) / rowData.noOfUnit;
  // };

  const onFocusedCellChanging = (e) => {
    const row = e.rows[e.newRowIndex];
    if (row?.rowType === "data" && isQuotationRoot(row.data)) {
      e.cancel = true;
    }
  };

  // const setCellValue = (newData, value, currentRowData) => {
  //   console.debug("[setCellValue]");
  //   console.debug("newData", newData);
  //   console.debug("value", value);
  //   console.debug("currentRowData", currentRowData);
  // };

  const onEditorPreparing = (e) => {
    const onValueChangedDefaultHandler = e.editorOptions.onValueChanged;

    if (e.parentType == "dataRow") {
      if (isQuotationRoot(e.row.data)) {
        e.editorOptions.readOnly = true;
        e.editorOptions.placeholder = "";
        return;
      }
      if (e.dataField.startsWith("c")) {
        e.editorOptions.onValueChanged = function (args) {
          e.setValue(args.value);

          salesGridRef.current.instance.cellValue(
            e.row.rowIndex,
            e.dataField.replace("c", "a"),
            e.row.data.noOfUnit == "NA" || e.row.data.noOfUnit == ""
              ? 0
              : (e.row.data.cost * args.value) / e.row.data.noOfUnit
          );

          let progRate = 0;

          for (const property in e.row.data) {
            if (property.startsWith("c2")) {
              progRate += e.row.data[property];
            }
          }

          salesGridRef.current.instance.cellValue(
            e.row.rowIndex,
            "progRate",
            progRate
          );

          onValueChangedDefaultHandler(args);
        };
      }
    }
  };

  const getColumns = useMemo(() => {
    const config = {
      calculateSponsorDisplayValue: calculateSponsorDisplayValue,
      calculateBeccoDisplayValue: calculateBeccoDisplayValue,
      calculateNADisplayValue: calculateNADisplayValue,
    };

    const _columns = columns(config);

    if (!quot.effectiveDate) return _columns;
    const startDate = new Date(quot.effectiveDate);
    if (Number.isNaN(startDate.getTime())) return _columns;
    // Always advance from the first day so dates such as January 31 do not skip February.
    startDate.setDate(1);
    startDate.setHours(0, 0, 0, 0);
    const today = new Date();
    const endDate = new Date(today.getFullYear(), today.getMonth(), 1);

    for (; startDate <= endDate; startDate.setMonth(startDate.getMonth() + 1)) {
      const startYearMonth = getYearMonth(startDate);

      _columns.push({
        caption: startYearMonth,
        columns: [
          {
            dataField: `c${startYearMonth}`,
            caption: "COUNT",
            width: 70,
            // allowEditing: true,
            dataType: "number",
            format: "0.00",
            // setCellValue: setCellValue,
            // editorOptions: {
            //   onValueChanged: onValueChanged,
            // },
            showEditorAlways: true,
            editorOptions: {
              placeholder: `Enter`,
              min: 0,
            },
          },
          {
            dataField: `a${startYearMonth}`,
            caption: "AMOUNT",
            width: 80,
            dataType: "number",
            format: "#,##0",
            allowEditing: false,
            // calculateCellValue: calculateCellValue,
            // calculateDisplayValue: (rowData) => {
            //   calculateDisplayValue(rowData, `c${startYearMonth}`);
            // },
            // calculateDisplayValue: calculateDisplayValue,
          },
        ],
      });
    }

    return _columns;
  }, [
    calculateSponsorDisplayValue,
    calculateBeccoDisplayValue,
    calculateNADisplayValue,
    quot.effectiveDate,
  ]);

  const onCellPrepared = (e) => {
    if (e.rowType == "header") {
      e.cellElement.style.fontWeight = "bold";
      e.cellElement.style.textAlign = "center";
      e.cellElement.style.backgroundColor = "#A9D08E";

      if (e.column.caption == "AMOUNT") {
        e.cellElement.style.backgroundColor = "#007048";
        e.cellElement.style.color = "#FFF";
      }
    } else if (e.rowType == "data" && isQuotationRoot(e.data)) {
      e.cellElement.style.backgroundColor = "#007048";
      e.cellElement.style.color = "#FFF";
    }
  };

  const onExporting = (e) => {
    salesGridRef.current.instance.clearFilter();

    e.component.beginUpdate();
    e.component.columnOption("quotNo", "visible", true);
    e.component.columnOption("codeNo", "visible", true);

    const workbook = new Workbook();

    workbook.creator = "BeTree";
    workbook.created = new Date();

    const worksheet = workbook.addWorksheet("Sales");

    worksheet.properties.defaultRowHeight = 13.5;

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
      customizeCell: ({ gridCell, excelCell }) => {
        excelCell.font = {
          size: 10,
        };

        excelCell.border = {
          top: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        };

        if (gridCell.rowType === "data") {
          if (gridCell.column.dataField) {
            if (
              gridCell.column.dataField == "unitCost" ||
              gridCell.column.dataField == "cost" ||
              gridCell.column.dataField.startsWith("a")
            ) {
              if (gridCell.value && !isNaN(gridCell.value)) {
                excelCell.value = parseInt(gridCell.value, 10);
                excelCell.numFmt = "#0,000";
              }
            }

            // if (
            //   !gridCell.column.dataField.startsWith("c") &&
            //   gridCell.column.dataField == "cost"
            // ) {
            //   excelCell.fill = {
            //     type: "pattern",
            //     pattern: "solid",
            //     fgColor: { argb: "FBFBFBF" },
            //   };
            // }
          } else {
            // Reponsibility
            excelCell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FBFBFBF" },
            };
          }
        }
      },
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], {
            type: "application/octet-stream",
          }),
          `Sales_${quot.quotNo}.xlsx`
        );
      });

      e.component.columnOption("quotNo", "visible", false);
      e.component.columnOption("codeNo", "visible", false);
      e.component.endUpdate();
    });
  };

  // const commentCellRender = (data) => {
  //   console.debug("[commentCellRender]");

  //   return <CommentCell onCommentIconClick={onCommentIconClick} data={data} />;
  // };

  const onInitialized = ({ component, element }) => {
    observerInstance.subscribe(
      component,
      element.parentNode,
      component.repaint,
      100
    );
  };

  return (
    <>
      <DataGrid
        id="salesGrid"
        ref={salesGridRef}
        dataSource={dataSource}
        columns={getColumns}
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnResizingMode="widget"
        rowAlternationEnabled={true}
        showBorders={true}
        showRowLines={true}
        showColumnLines={true}
        width={"100%"}
        height={"100%"}
        //   height={440}
        repaintChangesOnly={true}
        highlightChanges={true}
        columnAutoWidth={true}
        wordWrapEnabled={true}
        style={{
          maxHeight: "800px",
        }}
        onFocusedCellChanging={onFocusedCellChanging}
        onEditorPreparing={onEditorPreparing}
        onCellPrepared={onCellPrepared}
        onExporting={onExporting}
        // onInitialized={onInitialized}
      >
        {/* <GroupPanel visible={true} /> */}
        {/* <Grouping autoExpandAll={true} /> */}
        <SearchPanel visible={true} highlightCaseSensitive={true} width={240} />
        <Scrolling
          mode={"virtual"}
          rowRenderingMode={"virtual"}
          columnRenderingMode={"virtual"}
          showScrollbar={"always"}
        />
        <HeaderFilter visible={true} />
        <FilterRow visible={true} applyFilter={"auto"} />
        <Paging enabled={false} />
        <Sorting mode={"none"} />
        <Selection mode="single" />
        {/* <ColumnFixing enabled={true} /> */}
        <ColumnChooser height={"340px"} enabled={true} mode={"dragAndDrop"}>
          <Position
            my={"right top"}
            at={"right bottom"}
            of={".dx-datagrid-column-chooser-button"}
          />
        </ColumnChooser>

        <Template name="listNo" render={groupCellRender} />
        {/* <Template name="comment" render={commentCellRender} /> */}

        <StateStoring
          enabled={true}
          type={"localStorage"}
          storageKey={`SalesManagement.Sales.SalesGrid.${quot.quotNo}`}
        />

        <Editing
          mode={"batch"}
          allowUpdating={true}
          selectTextOnEditStart={true}
          startEditAction={"dblClick"}
        />

        <Export enabled={true} />

        {/* <Column
        dataField={"listNo"}
        groupIndex={1}
        caption={"List No"}
        dataType={"number"}
        groupCellRender={groupCellRender}
      />
      <Column dataField={"no"} caption={"No"} dataType={"string"} width={60} />
      <Column
        dataField={"taskCat"}
        caption={"Task Category"}
        dataType={"string"}
        // width={500}
      />
      <Column caption={"Responsibility"}>
        <Column
          caption={"Sponsor"}
          calculateDisplayValue={calculateSponsorDisplayValue}
          width={75}
        />
        <Column
          caption={"BECCO"}
          calculateDisplayValue={calculateBeccoDisplayValue}
          width={75}
        />
        <Column
          caption={"N/A"}
          calculateDisplayValue={calculateNADisplayValue}
          width={75}
        />
      </Column>
      <Column
        dataField={"unit"}
        caption={"Unit"}
        dataType={"string"}
        width={110}
      />
      <Column
        dataField={"noOfUnit"}
        caption={"No. of Unit"}f
        dataType={"string"}
        width={80}
      />
      <Column
        dataField={"unitCost"}
        caption={"Unit Cost"}
        dataType={"number"}
        format={"#0,000"}
      />
      <Column
        dataField={"cost"}
        caption={"Cost"}
        dataType={"number"}
        format={"#0,000"}
      />
      <Column width={50} />
      <Column
        dataField={"progRate"}
        caption={"Progress Rate"}
        dataType={"number"}
      /> */}
      </DataGrid>
      <Comment
        commentPopupVisible={commentPopupVisible}
        setCommentPopupVisible={setCommentPopupVisible}
        cTaskCategory={cTaskCategory}
      />
    </>
  );
}
